<template>
  <header class="api-header">
    <div class="header__nav">
      <button type="button" @click.capture="$emit('toggleMenu')">
        <SvgIcon :icon="isMobile && isMenuOpen ? 'x' : 'menu'" class="api-header__menu-btn" />
      </button>
      <RouterLink to="/" class="header__nav-home">
        <SvgIcon icon="home" />
        <span v-if="!isMobile"> Вернуться на главную </span>
      </RouterLink>
    </div>
    <div class="header__container">
      <RouterLink to="/profile" class="header__link">
        <SvgIcon v-if="isMobile" icon="user" />
        <span v-else>
          {{ authStore.user?.name ?? 'Admin' }}
        </span>
      </RouterLink>
      <ContextMenu :items="userMenuItems" class="header__context-menu" @logout="logout">
        <!-- @vue-ignore -->
        <template #icon>
          <button type="button">
            <SvgIcon icon="chevron-down" />
          </button>
        </template>
      </ContextMenu>
    </div>
  </header>
</template>

<script lang="ts" src="./ApiDocsHeader.ts"></script>

<style scoped lang="scss" src="./ApiDocsHeader.scss"></style>
